import {
  all, takeLatest, put, call, take, fork,
} from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';
import actions from './actions';
import authActions from '../auth/actions';

function createPlansChannel() {
  const db = getFirestore();
  const ref = doc(db, 'config', 'meagendaPlans');
  return eventChannel((emit) => {
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          emit({ data: snap.data() });
        } else {
          emit({ data: null });
        }
      },
      (error) => emit({ error }),
    );
    return unsubscribe;
  });
}

export function* loadMeagendaPlans() {
  yield takeLatest([
    authActions.LOGIN_SUCCESS,
    actions.LOAD_MEAGENDA_PLANS_REQUEST,
  ], function* () {
    const channel = yield call(createPlansChannel);
    try {
      while (true) {
        const event = yield take(channel);
        if (event.error) {
          console.warn('[meagendaPlans] erro lendo /config/meagendaPlans:', event.error);
          yield put({
            type: actions.MEAGENDA_PLANS_ERROR,
            payload: event.error?.message || 'Erro ao carregar config de planos.',
          });
        } else {
          yield put({ type: actions.MEAGENDA_PLANS_UPDATED, payload: event.data });
        }
      }
    } catch (error) {
      console.warn('[meagendaPlans] saga falhou:', error);
      yield put({
        type: actions.MEAGENDA_PLANS_ERROR,
        payload: error?.message || 'Erro ao carregar config de planos.',
      });
    } finally {
      channel.close();
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(loadMeagendaPlans),
  ]);
}
